import { render, staticRenderFns } from "./ECopyBox.vue?vue&type=template&id=ba78dba0&scoped=true&"
import script from "./ECopyBox.vue?vue&type=script&lang=js&"
export * from "./ECopyBox.vue?vue&type=script&lang=js&"
import style0 from "./ECopyBox.vue?vue&type=style&index=0&id=ba78dba0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba78dba0",
  null
  
)

export default component.exports